var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light"},[_c('b-container',{staticClass:"text-center py-3"},[_c('span',{staticClass:"text-muted"},[_vm._v(" © ZoopLocal "+_vm._s(_vm.currentYear)+". All rights reserved. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }